import { ObjectUtility } from "../../../../../../../base/utilities";
import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectRelationalItemBean } from "../../../beans";
import { IntegerTranslator } from "../../values";
import { LinkedOjbectTranslator } from "./LinkedObjectTranslator";
import { ILinkedObjectTranslatable } from "./ILinkedObjectTranslatable";

export interface LinkedPageObjectTranslateOption {
  isItemBeanEnable?: (b: IXElementContentsObjectRelationalItemBean) => boolean;
  complementBean?: (b: IXElementContentsObjectRelationalItemBean) => void;
}

export class LinkedPageObjectTranslator implements ILinkedObjectTranslatable<ILinkedPageObjectSpecifiable> {
  constructor(private readonly _option?: LinkedPageObjectTranslateOption) {
    this.base = new LinkedOjbectTranslator(_option ? _option.isItemBeanEnable : undefined);
  }

  from(bean: IXElementContentsObjectRelationalItemBean): ILinkedPageObjectSpecifiable {
    const result = this.base.from(bean) as ILinkedPageObjectSpecifiable;
    if (!!result) {
      result.pageKey = this.integer.from(bean["@pagekey"]);
    }
    return result;
  }

  to(object: ILinkedPageObjectSpecifiable): IXElementContentsObjectRelationalItemBean {
    // 順番をv1の出力順に合わせないと比較が大変なのでmergeして合わせる.
    const result = ObjectUtility.mergeShallowly(
      {
        "@pagekey": this.integer.to(object.pageKey),
      },
      this.base.to(object));
    if (this._option && this._option.complementBean) {
      this._option.complementBean(result);
    }
    return result;
  }

  private readonly base = new LinkedOjbectTranslator();
  private readonly integer = new IntegerTranslator();
}
